<template>
	<v-container grid-list-xl>
		<v-layout row wrap>      
            <v-flex lg6>              
              <label class="blackLabel">Date From:</label>
              <date-picker v-model="startDate" format="YYYY-MM-DD" lang="en"></date-picker>
            </v-flex>
            <v-flex lg6>
              <label class="blackLabel">Date From:</label>
              <date-picker v-model="endDate" format="YYYY-MM-DD" lang="en"></date-picker>
            </v-flex>
          <v-flex lg12 style="padding-bottom: 0px;">
            <label class="blackLabel">Customer Region:</label>
            <v-select @input="fncCheckRegions()" v-model="objCustomerRegion" :items="objQuoteFilters.regions" item-value="id"  item-text="name" autocomplete multiple outline>
            </v-select>
          </v-flex>
          <v-flex lg12 style="padding-bottom: 0px;padding-top: 0px;">               
            <label class="blackLabel">Originator:</label>            
            <v-select @input="fncCheckOriginators()" v-model="objOriginator" :items="objQuoteFilters.originators" item-value="id" item-text="name" autocomplete multiple outline> </v-select>
          </v-flex>
          <v-flex lg12 style="padding-bottom: 0px;padding-top: 0px;">
            <label class="blackLabel">Status:</label>
            <v-select @input="fncCheckStatus()" v-model="objStatus" :items="objQuoteFilters.status" item-value="id" item-text="name" autocomplete multiple outline></v-select>
          </v-flex>
          <v-flex lg12 style="padding-bottom: 0px;padding-top: 0px;">
            <label class="blackLabel">Customer Company:</label>
            <v-select @input="fncCheckCompany()" v-model="objCustomerCompany" :items="objQuoteFilters.companies" item-value="id" item-text="name" autocomplete multiple outline></v-select>
          </v-flex>
          <v-flex lg12 style="padding-bottom: 0px;padding-top: 0px;">
            <label class="blackLabel">Customer User:</label>
            <v-select @input="fncCheckUser()" v-model="objCustomerUser" :items="objQuoteFilters.users" item-value="id" item-text="name" autocomplete multiple outline></v-select>
          </v-flex>
          <v-flex lg12 style="padding-bottom: 0px;padding-top: 0px;">
            <label class="blackLabel">Project:</label>
            <v-select @input="fncCheckProject()" v-model="objProject" :items="objQuoteFilters.projects" item-value="id" item-text="name" autocomplete multiple outline></v-select>
          </v-flex>
          <v-flex lg12 style="padding-bottom: 0px;padding-top: 0px;">
            <label class="blackLabel">Specifier:</label>
            <v-select @input="fncCheckSpecifier()" v-model="objSpecifier" :items="objQuoteFilters.specifiers" item-text="name" item-value="id" autocomplete multiple outline></v-select>
          </v-flex>                 
			<div class="pl-4 pr-1 pb-4 buttonHolder">
				<div style="float: right">
					<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>
					<!--<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>-->
					<v-btn color="success" class="text-xs-right" @click.stop="fncGenerateReport('true')">Generate</v-btn>
                  <v-btn color="success" class="text-xs-right" @click.stop="fncClearFilters()">Clear Filters</v-btn>
				</div>	
			</div>							
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	import draggable from 'vuedraggable'
	import DatePicker from 'vue2-datepicker'
	export default {
	  name: 'Settings',
      data() {       
        return {			                
                objCustomerRegion: window.localStorage.qRegion != undefined && window.localStorage.qRegion[0] != null ? window.localStorage.qRegion.split(',') : '',
                objOriginator: window.localStorage.qOriginator != undefined && window.localStorage.qOriginator[0] != null ? window.localStorage.qOriginator.split(',') : '',
                objStatus: window.localStorage.qStatus != undefined && window.localStorage.qStatus[0] != null ? window.localStorage.qStatus.split(',') : '',
                objCustomerCompany: window.localStorage.qCompany != undefined && window.localStorage.qCompany[0] != null ? window.localStorage.qCompany.split(',') : '',
                objCustomerUser: window.localStorage.qCustomer != undefined && window.localStorage.qCustomer[0] != null ? window.localStorage.qCustomer.split(',') : '',
                objProject: window.localStorage.qProject != undefined && window.localStorage.qProject[0] != null ? window.localStorage.qProject.split(',') : '',
                objSpecifier: window.localStorage.qSpecifier != undefined && window.localStorage.qSpecifier[0] != null ? window.localStorage.qSpecifier.split(',') : '',
				objQuoteSettingsActive: [],
				objQuoteSettingsInactive: [],				
                startDate: window.localStorage.qStartDate,
                endDate: window.localStorage.qEndDate
			};
		},		
      methods: {
        fncCheckSpecifier() {
          if ((this.objSpecifier[0] == 'all' || this.objSpecifier[(this.objSpecifier.length - 1)] == 'all') && this.objQuoteFilters.specifiers.length != this.objSpecifier.length) {
            var selectedAll = ['all'];
            for (var n in this.objQuoteFilters.specifiers) {
              selectedAll.push(this.objQuoteFilters.specifiers[n].id);
            }
            this.objSpecifier = selectedAll;
          } else {
            if ((this.objSpecifier[0] == 'all' || this.objSpecifier[(this.objSpecifier.length - 1)] == 'all') && this.objQuoteFilters.specifiers.length == this.objSpecifier.length) {

              if (this.objQuoteFilters.specifiers.length == this.objSpecifier.length) {

                var isAll = false;

                for (var i in this.objSpecifier) {
                  if (this.objSpecifier[1] == 'all') {
                    var isAll = true;
                    this.objSpecifier = this.objSpecifier.filter(function (e) { return e !== 'all' })
                  }
                }
                if (isAll == false) {
                  this.objSpecifier = [];
                }
              }
            }
          }
        },
        fncCheckProject() {          
          if ((this.objProject[0] == 'all' || this.objProject[(this.objProject.length - 1)] == 'all') && this.objQuoteFilters.projects.length != this.objProject.length) {            
            var selectedAll = ['all'];
            for (var n in this.objQuoteFilters.projects) {
              selectedAll.push(this.objQuoteFilters.projects[n].id);
            }
            this.objCustomerUser = selectedAll;
          } else {
            if ((this.objProject[0] == 'all' || this.objProject[(this.objProject.length - 1)] == 'all') && this.objQuoteFilters.projects.length == this.objProject.length) {

              if (this.objQuoteFilters.projects.length == this.objProject.length) {

                var isAll = false;

                for (var i in this.objProject) {
                  if (this.objProject[1] == 'all') {
                    var isAll = true;
                    this.objProject = this.objProject.filter(function (e) { return e !== 'all' })
                  }
                }
                if (isAll == false) {
                  this.objProject = [];
                }
              }
            }
          }
        },
        fncCheckUser() {
          if ((this.objCustomerUser[0] == 'all' || this.objCustomerUser[(this.objCustomerUser.length - 1)] == 'all') && this.objQuoteFilters.users.length != this.objCustomerUser.length) {
            var selectedAll = ['all'];
            for (var n in this.objQuoteFilters.users) {
              selectedAll.push(this.objQuoteFilters.users[n].id);
            }
            this.objCustomerUser = selectedAll;
          } else {
            if ((this.objCustomerUser[0] == 'all' || this.objCustomerCompany[(this.objCustomerUser.length - 1)] == 'all') && this.objQuoteFilters.users.length == this.objCustomerUser.length) {

              if (this.objQuoteFilters.users.length == this.objCustomerUser.length) {

                var isAll = false;

                for (var i in this.objCustomerUser) {
                  if (this.objCustomerUser[1] == 'all') {
                    var isAll = true;
                    this.objCustomerUser = this.objCustomerUser.filter(function (e) { return e !== 'all' })
                  }
                }
                if (isAll == false) {
                  this.objCustomerUser = [];
                }
              }
            }
          }
        },
        fncCheckCompany() {
          if ((this.objCustomerCompany[0] == 'all' || this.objCustomerCompany[(this.objCustomerCompany.length - 1)] == 'all') && this.objQuoteFilters.companies.length != this.objCustomerCompany.length) {
            var selectedAll = ['all'];
            for (var n in this.objQuoteFilters.companies) {
              selectedAll.push(this.objQuoteFilters.companies[n].id);
            }
            this.objCustomerCompany = selectedAll;
          } else {
            if ((this.objCustomerCompany[0] == 'all' || this.objCustomerCompany[(this.objCustomerCompany.length - 1)] == 'all') && this.objQuoteFilters.companies.length == this.objCustomerCompany.length) {

              if (this.objQuoteFilters.companies.length == this.objCustomerCompany.length) {

                var isAll = false;

                for (var i in this.objCustomerCompany) {
                  if (this.objCustomerCompany[1] == 'all') {
                    var isAll = true;
                    this.objCustomerCompany = this.objCustomerCompany.filter(function (e) { return e !== 'all' })
                  }
                }
                console.log( isAll );
                if (isAll == false) {
                  this.objCustomerCompany = [];
                }
              }
            }
          }
        },
        fncCheckRegions() {
          if ((this.objCustomerRegion[0] == 'all' || this.objCustomerRegion[(this.objCustomerRegion.length - 1)] == 'all') && this.objQuoteFilters.regions.length != this.objCustomerRegion.length) {
            var selectedAll = ['all'];
            for (var n in this.objQuoteFilters.regions) {
              selectedAll.push(this.objQuoteFilters.regions[n].id);
            }
            this.objCustomerRegion = selectedAll;
          } else {
            if ((this.objCustomerRegion[0] == 'all' || this.objCustomerRegion[(this.objCustomerRegion.length - 1)] == 'all') && this.objQuoteFilters.regions.length == this.objCustomerRegion.length) {

              if (this.objQuoteFilters.regions.length == this.objCustomerRegion.length) {

                var isAll = false;

                for (var i in this.objCustomerRegion) {
                  if (this.objCustomerRegion[1] == 'all') {
                    var isAll = true;
                    this.objCustomerRegion = this.objCustomerRegion.filter(function (e) { return e !== 'all' })
                  }
                }
                if (isAll == false) {
                  this.objCustomerRegion = [];
                }
              }
            }
          }
        },
        fncCheckOriginators() {         
          if ((this.objOriginator[0] == 'all' || this.objOriginator[(this.objOriginator.length-1)] == 'all' ) && this.objQuoteFilters.originators.length != this.objOriginator.length ) {
            var selectedAll = ['all'];            
            for (var n in this.objQuoteFilters.originators) {
              selectedAll.push(this.objQuoteFilters.originators[n].id);
            }
            this.objOriginator = selectedAll;
         } else {             
            if ((this.objOriginator[0] == 'all' || this.objOriginator[(this.objOriginator.length - 1)] == 'all') && this.objQuoteFilters.originators.length == this.objOriginator.length) {

              if (this.objQuoteFilters.originators.length == this.objOriginator.length) {

                var isAll = false;

                for ( var i in this.objOriginator ) {
                  if (this.objOriginator[1] == 'all') {
                    var isAll = true;                    
                    this.objOriginator = this.objOriginator.filter(function (e) { return e !== 'all' })
                  }
                }               
                if ( isAll == false ) {
                  this.objOriginator = [];
                }               
             }            
           }         
          }          
        },
        fncCheckStatus() {
          if ((this.objStatus[0] == 'all' || this.objStatus[(this.objStatus.length - 1)] == 'all') && this.objQuoteFilters.status.length != this.objStatus.length) {
            var selectedAll = ['all'];
            for (var n in this.objQuoteFilters.status) {
              selectedAll.push(this.objQuoteFilters.status[n].id);
            }
            this.objStatus = selectedAll;
          } else {
            if ((this.objStatus[0] == 'all' || this.objStatus[(this.objStatus.length - 1)] == 'all') && this.objQuoteFilters.status.length == this.objStatus.length) {

              if (this.objQuoteFilters.status.length == this.objStatus.length) {

                var isAll = false;

                for (var i in this.objStatus) {
                  if (this.objStatus[1] == 'all') {
                    var isAll = true;                    
                    this.objStatus = this.objStatus.filter(function (e) { return e !== 'all' })
                  }
                }
                if (isAll == false) {
                  this.objStatus = [];
                }
              }
            }
          }
        },
        fncClearFilters() {          
          this.objCustomerRegion = [];
          this.objOriginator = [];
          this.objStatus = [];
          this.objCustomerCompany = [];
          this.objCustomerUser = [];
          this.objProject = [];
          this.objSpecifier = [];
          this.startDate = '';
          this.endDate = '';
        },
			fncActivate(objActive) {
				this.$store.commit('fncActivate', objActive);				
			},
			fncDeactivate(objActive) {
				this.$store.commit('fncDeactivate', objActive);				
			},
			fncHideModal () {
				this.$store.commit('hideModal');
			},
            fncGenerateReport(hide) {
              this.$store.commit('fncEmptyQuoteList');
              if (this.objRegion != undefined && this.objRegion[0] == 'null') { this.objRegion.shift() }
              if (this.objStatus != undefined && this.objStatus[0] == 'null') { this.objStatus.shift() }
              if (this.objOriginator != undefined && this.objOriginator[0] == 'null') { this.objOriginator.shift() }
              if (this.objCustomerUser != undefined && this.objCustomerUser[0] == 'null') { this.objCustomerUser.shift() }
              if (this.objProject != undefined && this.objProject[0] == 'null') { this.objProject.shift() }
              if (this.objCustomerCompany != undefined && this.objCustomerCompany[0] == 'null') { this.objCustomerCompany.shift() }
              if (this.objSpecifier != undefined && this.objSpecifier[0] == 'null') { this.objSpecifier.shift() }
              this.$store.dispatch({
                type: 'fncPopulateQuoteList',
                reload: true,
                date_from: this.startDate == '' || this.startDate == undefined ? 'null' : this.startDate,
                date_to: this.endDate == '' || this.endDate == undefined ? 'null' : this.endDate,
                region: this.objCustomerRegion == '' || this.objCustomerRegion[0] == 'null' ? 'null' : this.objCustomerRegion,
                status: this.objStatus == '' || this.objStatus[0] == 'null' ? 'null' || this.objStatus[0] == 'null' : this.objStatus,
                originator: this.objOriginator == '' || this.objOriginator[0] == 'null' || this.objOriginator[0] == 'null' ? 'null' : this.objOriginator,
                customer: this.objCustomerUser == '' || this.objCustomerUser[0] == 'null' || this.objCustomerUser[0] == 'null' ? 'null' : this.objCustomerUser,
                project: this.objProject == '' || this.objProject[0] == 'null' || this.objProject[0] == 'null' ? 'null' : this.objProject,
                company: this.objCustomerCompany == '' || this.objCustomerCompany[0] == 'null' || this.objCustomerCompany[0] == 'null' ? 'null' : this.objCustomerCompany,
                specifier: this.objSpecifier == '' || this.objSpecifier[0] == 'null' || this.objSpecifier[0] == 'null' ? 'null' : this.objSpecifier,
                filter: true
              })
              if ( hide == 'true' ) {
                this.$store.commit('hideModal');
              }              
            },
            customFormatter(date) {
              return moment(date).format('YYY-mm-dd');
            }
		},
		computed: {
			...mapGetters([			
				'objAuthorize',				
				'globalModalParams',
				'quoteList',
                'objQuoteSettings',
                'objQuoteFilters'

			])
		},
		created() {
			/*for( var k in this.quoteList ) {				
				if( this.objCustomerRegion.indexOf(this.quoteList[k].customer_region) === -1 ) { this.objCustomerRegion.push(this.quoteList[k].customer_region); }				
				if( this.objOriginator.indexOf(this.quoteList[k].originator) === -1 ) { this.objOriginator.push(this.quoteList[k].originator); }				
				if( this.objStatus.indexOf(this.quoteList[k].status) === -1 ) { this.objStatus.push(this.quoteList[k].status); }				
			}
			this.objQuoteSettingsActive = this.objQuoteSettings;
			this.objQuoteSettingsInactive = this.objQuoteSettings;*/
		},
		 components: {
			  draggable,
			  DatePicker			  
		  }
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>